export type ShortcutPlatform = 'mac' | 'win';

export const getShortcutPlatform = (
  userAgent = typeof navigator === 'undefined' ? '' : navigator.userAgent,
): ShortcutPlatform => (/Mac|iPhone|iPad|iPod/.test(userAgent) ? 'mac' : 'win');

export const primaryModifierLabel = (platform = getShortcutPlatform()) =>
  platform === 'mac' ? '⌘' : 'Ctrl';

export const addFrShortcutHint = (platform = getShortcutPlatform()) =>
  `${primaryModifierLabel(platform)}+Shift+F`;

export const addPartsShortcutHint = (platform = getShortcutPlatform()) =>
  `${primaryModifierLabel(platform)}+Shift+P`;

export const editDamageShortcutHint = (platform = getShortcutPlatform()) =>
  `${primaryModifierLabel(platform)}+Shift+D`;

export const saveNotesShortcutHint = (platform = getShortcutPlatform()) =>
  `${primaryModifierLabel(platform)}+Enter`;

const usesPrimaryModifier = (
  event: Pick<KeyboardEvent, 'ctrlKey' | 'metaKey'>,
  platform = getShortcutPlatform(),
) => (platform === 'mac' ? event.metaKey : event.ctrlKey);

export const isAddFrShortcut = (event: KeyboardEvent) =>
  usesPrimaryModifier(event) &&
  event.shiftKey &&
  !event.altKey &&
  event.key.toLowerCase() === 'f';

export const isAddPartsShortcut = (event: KeyboardEvent) =>
  usesPrimaryModifier(event) &&
  event.shiftKey &&
  !event.altKey &&
  event.key.toLowerCase() === 'p';

export const isEditDamageShortcut = (event: KeyboardEvent) =>
  usesPrimaryModifier(event) &&
  event.shiftKey &&
  !event.altKey &&
  event.key.toLowerCase() === 'd';

export const isSaveNotesShortcut = (event: KeyboardEvent) =>
  usesPrimaryModifier(event) &&
  !event.shiftKey &&
  !event.altKey &&
  event.key === 'Enter';

export const isSelectPreviousLineShortcut = (event: KeyboardEvent) =>
  event.altKey && !event.shiftKey && event.key === 'ArrowUp';

export const isSelectNextLineShortcut = (event: KeyboardEvent) =>
  event.altKey && !event.shiftKey && event.key === 'ArrowDown';

export const isTypingTarget = (target: EventTarget | null) => {
  if (!(target instanceof HTMLElement)) return false;
  const tag = target.tagName;
  return (
    tag === 'INPUT' ||
    tag === 'TEXTAREA' ||
    tag === 'SELECT' ||
    target.isContentEditable
  );
};
